// removed by extract-text-webpack-plugin
module.exports = {"primary":"_4jVDA"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/AnswerBlock/components/ExplanationBlock/whiteButtonTheme.scss
// module id = 1173
// module chunks = 2